import { ReactNode } from 'react';

import PropTypes, { Validator } from 'prop-types';

export type User = {
  name: string;
  imageUrl?: string;
};

export const userShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
}) as Validator<User> & { isRequired: Validator<NonNullable<User>> };

export type Status = {
  text: ReactNode;
  color: string;
  subtext?: ReactNode;
};

export const statusShape = PropTypes.shape({
  text: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  subtext: PropTypes.node,
}) as Validator<Status> & { isRequired: Validator<NonNullable<Status>> };
